import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useUserEventsApi = () => {
  const addToast = useToastContext()

  const [eventsState, setEventsState] = useState({
    events: [],
    count: 0,
    isLoading: false,
    error: null,
  })

  async function getEvents(params) {
    try {
      setEventsState((currentEventsState) => ({
        ...currentEventsState,
        isLoading: true,
        error: null,
      }))
      let url = '/admins/userEvents'
      const response = await api.get(url, { params, includeToken: true })
      setEventsState({
        events: response.data.data,
        count: response.data.count,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setEventsState({ events: [], isLoading: false, error })
    }
  }

  async function deleteUserEvent(id) {
    try {
      setEventsState((currentEventsState) => ({
        ...currentEventsState,
        isLoading: true,
        error: null,
      }))
      await api.remove(`/userEvents/${id}`)
      setEventsState({
        isLoading: false,
        error: null,
      })
      setEventsState({
        events: eventsState.events.filter((elem) => elem.id !== id),
        count: Math.max((eventsState.count || 1) - 1, 0),
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Evento borrado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al borrar el evento: ${error.response.data.message}`
      )
      setEventsState({ isLoading: false, error })
    }
  }

  async function addInvitation(id, invitation, showToast = false) {
    try {
      setEventsState((currentEventsState) => ({
        ...currentEventsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.post(`/userEvents/${id}/invitations`, {
        ...invitation,
      })
      setEventsState({
        isLoading: false,
        error: null,
        getResponse: response,
      })
      if (showToast) {
        addToast(notificationTypes.success, 'Invitado agregado con exito!')
      }
    } catch (error) {
      setEventsState({
        isLoading: false,
        error: error?.response?.data?.message,
      })
      addToast(
        notificationTypes.error,
        error?.response?.data?.message || 'Lo sentimos ha ocurrido un error'
      )
    }
  }

  async function getUserEvent(id) {
    try {
      setEventsState((currentEventsState) => ({
        ...currentEventsState,
        isLoading: true,
        error: null,
      }))
      let url = `/userEvents/${id}`
      const response = await api.get(url)
      setEventsState({
        getResponse: response.data,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setEventsState({
        getReponse: {},
        isLoading: false,
        error: error?.response?.data || 'Ha ocurrido un error',
      })
    }
  }

  const state = {
    eventsState,
  }

  const methods = {
    getEvents,
    deleteUserEvent,
    getUserEvent,
    addInvitation,
  }

  return [state, methods]
}

export default useUserEventsApi
